module.exports = __webpack_public_path__ + "media/entities/5003-906c960c.png";